<script setup>
import { inject, ref } from 'vue';
import Dialog from 'primevue/dialog';
import SelecteurJeuDonnees from '@/components/generiques/SelecteurJeuDonnees.vue';
import { 
    apiExporterJeuxDonnees } from '@/services/ServiceModele.js';

const ouvrirJeuDonnees = inject('ouvrirJeuDonnees');
const appelerApiTelechargementModele = inject('appelerApiTelechargementModele');

const { donnees } = defineProps({
    donnees: Object
});

const visible = defineModel('visible', {
    type: Boolean
});

const jeuxSelectionnes = ref([]);

function estJeuCourant(jeuDonnees) {
    return jeuDonnees.id === donnees.jeuDonneesCourant.id;
}

function ouvrir(jeu) {
    ouvrirJeuDonnees(jeu);
    visible.value = false;
}

function exporterDonnees(jeux) {
    appelerApiTelechargementModele(apiExporterJeuxDonnees, jeux);
}

</script>

<template>
    <Dialog 
        v-model:visible="visible" 
        modal>
            <template #header>
                <label class="titre">Jeux de données du modèle</label>
            </template>
            <div class="corps-modale-jeux-donnees">
                <SelecteurJeuDonnees 
                    v-model:selection="jeuxSelectionnes"
                    :campagne-par-defaut="donnees.jeuDonneesCourant.campagne"
                    :noms-campagnes="donnees.valeursJeuxExistants.campagnes"
                    :selection-multiple="true"
                    :est-jeu-selectionne-par-defaut="estJeuCourant" />
            </div>
            <template #footer>
                <button 
                    class="bouton fas fa-download" 
                    :disabled="jeuxSelectionnes.length === 0"
                    v-tooltip="'Télécharger un export des données'"
                    @click="exporterDonnees(jeuxSelectionnes)"/>
                <button 
                    class="bouton fas fa-eye" 
                    :disabled="jeuxSelectionnes.length !== 1 || estJeuCourant(jeuxSelectionnes[0])"
                    v-tooltip="'Ouvrir'"
                    @click="ouvrir(jeuxSelectionnes[0])"/>
            </template>
    </Dialog>
</template>

<style scoped>

.titre {
    margin-right: 10px;
}

.contenu-colonne {
    cursor: inherit;
}

</style>